import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { ScheduledMaintenanceTableComponent } from "./scheduled-maintenance-table.component";

@NgModule({
  declarations: [ScheduledMaintenanceTableComponent],
  imports: [SharedModule],
  exports: [ScheduledMaintenanceTableComponent],
})
export class ScheduledMaintenanceTableModule {}
